__turbopack_context__.v({
  "group": "ButtonGroup-module__B8AfLa__group",
  "groupFullWidth": "ButtonGroup-module__B8AfLa__groupFullWidth",
  "item": "ButtonGroup-module__B8AfLa__item",
  "item--active": "ButtonGroup-module__B8AfLa__item--active",
  "item--first": "ButtonGroup-module__B8AfLa__item--first",
  "item--inactive": "ButtonGroup-module__B8AfLa__item--inactive",
  "item--last": "ButtonGroup-module__B8AfLa__item--last",
  "item--middle": "ButtonGroup-module__B8AfLa__item--middle",
  "item--only": "ButtonGroup-module__B8AfLa__item--only",
});
